import React from 'react';

export function Footer() {
  return (
    <footer className="border-t border-border">
      <div className="max-w-wide mx-auto px-6 md:px-12 py-10 md:py-24">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-x-6 gap-y-8 md:gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <a href="/" className="inline-block mb-3">
              <img 
                src="/logo-sqwish-full-transparent.png" 
                alt="Sqwish Labs" 
                className="h-8 w-auto"
              />
            </a>
            <p className="font-body text-body-sm text-foreground-tertiary leading-relaxed max-w-xs">
              Small, specialised models <br/>that keep learning in production
            </p>
          </div>

          {/* Research */}
          <div>
            <h4 className="text-label font-mono text-foreground-muted mb-3">Research</h4>
            <ul className="space-y-2">
              <li>
                <a href="/manifesto" className="font-body text-body-sm text-foreground-tertiary hover:text-foreground transition-colors">
                  Manifesto
                </a>
              </li>
              <li>
                <a href="/routerarena-playground" className="font-body text-body-sm text-foreground-tertiary hover:text-foreground transition-colors">
                  Router Lab
                </a>
              </li>
            </ul>
          </div>

          {/* Solutions */}
          <div>
            <h4 className="text-label font-mono text-foreground-muted mb-3">Solutions</h4>
            <ul className="space-y-2">
              <li>
                <a href="/onehot" className="font-body text-body-sm text-foreground-tertiary hover:text-foreground transition-colors">
                  OneHot
                </a>
              </li>
            </ul>
          </div>

          {/* Developers */}
          <div>
            <h4 className="text-label font-mono text-foreground-muted mb-3">Developers</h4>
            <ul className="space-y-2">
              <li>
                <a href="https://docs.sqwish.ai" className="font-body text-body-sm text-foreground-tertiary hover:text-foreground transition-colors">
                  Docs
                </a>
              </li>
              <li>
                <a href="https://docs.sqwish.ai/api-reference/overview" className="font-body text-body-sm text-foreground-tertiary hover:text-foreground transition-colors">
                  API reference
                </a>
              </li>
              <li>
                <a href="https://docs.sqwish.ai/guides/pricing" className="font-body text-body-sm text-foreground-tertiary hover:text-foreground transition-colors">
                  Pricing
                </a>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h4 className="text-label font-mono text-foreground-muted mb-3">Connect</h4>
            <div className="flex items-center gap-4">
              <a 
                href="https://www.linkedin.com/company/sqwish-ai/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-foreground-tertiary hover:text-foreground transition-colors"
                aria-label="LinkedIn"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </a>
              <a 
                href="mailto:hello@sqwish.ai" 
                className="text-foreground-tertiary hover:text-foreground transition-colors"
                aria-label="Email"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-5 border-t border-border flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <p className="font-body text-body-sm text-foreground-muted">
            © 2026 Sqwish Labs. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="https://console.sqwish.ai/privacy" className="font-body text-body-sm text-foreground-muted hover:text-foreground transition-colors">Privacy</a>
            <a href="https://console.sqwish.ai/terms" className="font-body text-body-sm text-foreground-muted hover:text-foreground transition-colors">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
